import { ReactComponent as BackArrowIcon } from 'core/assets/images/icones/backArrow.svg'
import { ReactComponent as AddDocuments } from 'lauria/assets/images/mobile/addDocuments.svg'
import { ReactComponent as AddDocumentsDark } from 'lauria/assets/images/mobile/addDocumentsDark.svg'
import React from 'react'
import { useTranslation } from 'react-i18next'

type PromptFormActionBarProps = {
  displayDocs: boolean
  isDarkTheme: boolean
  onCancel: (event: React.MouseEvent<HTMLButtonElement>) => void
  onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void
  onReturnToForm: (event: React.MouseEvent<HTMLButtonElement>) => void
  onToggleDisplayDocs: () => void
}

export const PromptFormActionBar: React.FC<PromptFormActionBarProps> = ({
  displayDocs,
  isDarkTheme,
  onCancel,
  onSubmit,
  onReturnToForm,
  onToggleDisplayDocs,
}) => {
  const { t } = useTranslation()

  if (displayDocs) {
    return (
      <div className="prompt-form-action-bar">
        <button
          type="button"
          className="btn prompt-form-action-return md:hidden"
          onClick={onReturnToForm}
        >
          <BackArrowIcon className="icon" />
          {t('prompts.form.button.promptReturn')}
        </button>
      </div>
    )
  }

  return (
    <div className="prompt-form-action-bar">
      <button
        type="button"
        className="small-btn cancel prompt-form-action-cancel"
        onClick={onCancel}
      >
        {t('global.form.button.cancel')}
      </button>
      <button
        type="button"
        className="small-btn default prompt-form-action-submit"
        onClick={onSubmit}
      >
        {t('prompts.form.button.validate')}
      </button>
      <button
        type="button"
        className="prompt-form-action-docs md:hidden"
        onClick={onToggleDisplayDocs}
        aria-label={t('prompts.form.attachDocuments')}
      >
        {isDarkTheme ? <AddDocumentsDark /> : <AddDocuments />}
      </button>
    </div>
  )
}
